import { BikeSpec } from './types';

/** Honda CRF250R (2024). Honda spec sheet: 249 cc 4T, 5 speed, 107 kg wet (about 101 kg dry). */
export const CRF250R: BikeSpec = {
  id: 'crf250r', brand: 'Honda', name: 'CRF250R', year: 2024, kind: 'mx', stroke: '4T', displacement: 249,
  dryMass: 101, peakPower: 28.5, peakPowerRpm: 13000, peakTorque: 27, peakTorqueRpm: 10500, limiterRpm: 14400, idleRpm: 2000,
  torqueCurve: [[2000, 0.42], [5000, 0.64], [8000, 0.86], [10500, 1], [13000, 0.8], [14400, 0.66]],
  primary: 3.304, gearbox: [2.357, 1.833, 1.5, 1.261, 1.095], finalDrive: 49 / 13,
  travelFront: 310, travelRear: 313, seatHeight: 965, wheelbase: 1481,
  level: 'intermediate', discipline: 'track', livery: 'honda',
  model: { file: 'fleet/crf250r.glb', base: 'Honda CRF250R', approximate: false },
  audio: { set: '4t', pitch: 1.12 },
  estimated: ['dryMass', 'peakPower', 'peakTorque', 'limiterRpm', 'torqueCurve', 'gearbox'],
};
